import component from './AlphaFlag'

export default component
